// extracted by css-extract-rspack-plugin
export default {"cls1":"Search-cls1_NcP","cls2":"Search-cls2_GsK Search-cls1_NcP"};